module.exports = __webpack_public_path__ + "img/hote.6efcaca3.jpg";